import { render } from "./avatar.vue?vue&type=template&id=ae459e96&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"

import "./avatar.vue?vue&type=style&index=0&id=ae459e96&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ae459e96"

export default script